module.exports = __webpack_public_path__ + "static/media/BARTexample.413b6eb5.png";